import { render } from "./UnilateralNonTrRegistry.vue?vue&type=template&id=14ef1e7c&scoped=true"
import script from "./UnilateralNonTrRegistry.vue?vue&type=script&lang=js"
export * from "./UnilateralNonTrRegistry.vue?vue&type=script&lang=js"

import "./UnilateralNonTrRegistry.vue?vue&type=style&index=0&id=14ef1e7c&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ef1e7c"]])

export default __exports__